import axios from "axios";

// const baseUrl = config('const.app_url');
// const baseUrl = 'https://www.icapital.mn';
// const baseUrl = 'http://localhost:8000';
export default {
  async getCashOutRequests(params = {}) {
    return axios.get("/api/enduser/deposit/cashout/request", { params });
  },
  async createRequest(model) {
    return axios.post("/api/enduser/account/withdraw", model);
  },
  async cancelRequest(request) {
    // TODO: end orj bga ID-g ni model-ees ni olj tavix
    return axios.post(
      `/api/enduser/deposit/cashout/request/${request.id}/cancel`,
      request,
    );
  },
  async generateQr(amount) {
    return axios.post("/api/enduser/account/invoice", { amount });
  },
  async generateSocialPayQr(amount) {
    return axios.post("/api/enduser/account/cash-in/socialpay-invoice", { amount });
  },
  async generateQrPayment(data) {
    return axios.post("/api/enduser/payment/invoice", data);
  },
  async generateSocialPayQrPayment(data) {
    return axios.post("/api/enduser/payment/socialpay-invoice", data);
  },
  async nominalPayment(data) {
    return axios.post("/api/enduser/payment/nominal", data);
  },
};
